import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

function Navbar() {
  const { isDark, toggleTheme } = useTheme();
  const location = useLocation();

  const navStyles = isDark ? {
    backgroundColor: '#2A2A2A',
    borderBottomLeftRadius: '0.5rem',
    borderBottomRightRadius: '0.5rem'
  } : {
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: '0.5rem',
    borderBottomRightRadius: '0.5rem'
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 ${isDark ? '' : 'bg-gray-50'}`}>
      <div className="max-w-6xl mx-auto">
        <div style={navStyles} className="flex items-center justify-between h-16 px-8">
          <Link to="/" className={`flex items-center ${isDark ? 'text-hack-accent' : 'text-cyan-600'} gap-2 font-bold text-xl hover:text-[#00ffff]/90 transition-colors`}>
            HackBench
          </Link>
          <div className="flex items-center space-x-6">
            <Link
              to="/"
              className={`transition-colors font-medium ${location.pathname === '/' ? (isDark ? 'text-hack-accent' : 'text-cyan-600') : (isDark ? 'text-gray-200 hover:text-hack-accent' : 'text-gray-600 hover:text-cyan-600')}`}
            >
              Home
            </Link>
            <Link
              to="/leaderboard"
              className={`transition-colors font-medium ${location.pathname === '/leaderboard' ? (isDark ? 'text-hack-accent' : 'text-cyan-600') : (isDark ? 'text-gray-200 hover:text-hack-accent' : 'text-gray-600 hover:text-cyan-600')}`}
            >
              Leaderboard
            </Link>
            <Link
              to="/challenges"
              className={`transition-colors font-medium ${location.pathname === '/challenges' ? (isDark ? 'text-hack-accent' : 'text-cyan-600') : (isDark ? 'text-gray-200 hover:text-hack-accent' : 'text-gray-600 hover:text-cyan-600')}`}
            >
              Challenges
            </Link>
            <Link
              to="/about"
              className={`transition-colors font-medium ${location.pathname === '/about' ? (isDark ? 'text-hack-accent' : 'text-cyan-600') : (isDark ? 'text-gray-200 hover:text-hack-accent' : 'text-gray-600 hover:text-cyan-600')}`}
            >
              About
            </Link>
            <a 
              href="https://github.com/ElectrovoltSec/HackBench"
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-colors font-medium ${isDark ? 'text-gray-200 hover:text-hack-accent' : 'text-gray-600 hover:text-cyan-600'}`}
            >
              Dataset
            </a>
            <button
              onClick={toggleTheme}
              className={`p-1 rounded-md transition-colors ${isDark ? 'text-hack-accent hover:bg-hack-accent/10' : 'text-cyan-600 hover:bg-cyan-100'}`}
              aria-label="Toggle dark mode"
            >
              {isDark ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
